export default "__VITE_ASSET__BCpgBPq1__"